<template>
    <painel-component :title="'Editar Items'">
        <error-component :errors="errors" v-if="showError"/>

        <div class="btn-close" @click="$emit('close')"></div>
        <form>
            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <label>Nome</label>
                    <input-component v-model="formDate.name" type-input="text"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <QuillEditor :contentType="'html'" ref="myEditor" v-model:content="formDate.notice" theme="snow"
                                 style="height: 250px; width: 100%;" :toolbar="toolbar"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <buttons-default :items="buttonDefault" @submit="submit"/>
                </row-col-component>
            </row-component>
        </form>
    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowColComponent from '@/components/row/RowColComponent';
import RowComponent from '@/components/row/RowComponent';
import InputComponent from "@/components/forms/InputComponent";
import ButtonsDefault from "@/components/buttons/ButtonsDefault";
import {QuillEditor, Quill} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

var Size = Quill.import("attributors/style/size");

Size.whitelist = [
    "8px",
    "9px",
    "10px",
    "11px",
    "12px",
    "14px",
    "18px",
    "24px",
    "36px",
    "48px",
    "64px",
    "82px",
    "150px",
];
Quill.register(Size, true);

import {useToast} from "vue-toastification";
import ErrorComponent from "@/components/alerts/ErrorComponent.vue";

const toast = useToast()

export default {
    name: 'NoticeUpdateItems',
    components: {
        ErrorComponent,
        PainelComponent,
        RowColComponent,
        RowComponent,
        InputComponent,
        ButtonsDefault,
        QuillEditor
    },

    props: {
        id: {required: true},
        idapp: {required: true}
    },

    created() {
        this.loadNoticeAddItems()
    },

    data() {
        return {
            buttonDefault: {
                type: 'button',
                icon: 'save',
                name: 'Salvar',
                title: 'Salvar'
            },

            formDate: {
                id: this.id,
                app_id: this.idapp,
                name: '',
                notice: ''
            },

            params: {
                id: this.id,
                idapp: this.idapp
            },

            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['link', 'image'],
                [{'header': 1}, {'header': 2}],               // custom button values
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                [{'direction': 'rtl'}],                         // text direction

                [{
                    size: [
                        "8px",
                        "9px",
                        "10px",
                        "11px",
                        "12px",
                        "14px",
                        "18px",
                        "24px",
                        "36px",
                        "48px",
                        "64px",
                        "82px",
                        "150px",
                    ],
                },
                ], // custom dropdown
                [{'header': [1, 2, 3, 4, 5, 6, false]}],

                [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                [{'align': []}],                                        // remove formatting button
            ],

            showError: false,
            errors: []

        }
    },

    methods: {

        loadNoticeAddItems() {
            this.$store.dispatch("loadNoticeAddItems", this.params)
                .then((r) => {
                    this.formDate = r;
                    this.$refs.myEditor.setHTML(r.notice)
                })
                .catch(() => {
                    toast.error('Erro desconhecido', {timeout: 1500})
                });
        },

        submit() {
            this.$store.dispatch('updateNoticeAddItems', this.formDate)
                .then(() => {
                    toast.success('Item atualizado com sucesso', {timeout: 1500})
                    this.showError = false
                    this.errors = []
                })
                .catch((r) => {
                    toast.error('Erro ao atualizar item', {timeout: 1500})
                    this.showError = true
                    this.errors = r.response.data.errors;
                })
        },
    },
}
</script>

<style scoped>
.btn-close {
    top: 0;
    right: 0;
    margin: 2%;
    position: absolute;
}
</style>

<style>
.ql-snow .ql-picker.ql-size .ql-picker-label::before, .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: attr(data-value) !important;
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    overflow: auto;
    height: 250px;
    border-color: #d1d5db;
}
</style>